<nwt-power-supply></nwt-power-supply>
